// FILE: /src/services/user.profile.js (FULLY UPDATED)

import axiosServices from "./axios";

// --- START: NEW SERVICE FOR USAGE STATS ---
// export const fetchUsageStats = async () => {
//   try {
//     const response = await axiosServices.get(`/user/usage-stats`);
//     return response.data;
//   } catch (error) {
//     console.error("Error fetching usage stats:", error);
//     throw new Error(error?.response?.data?.message || "Failed to fetch usage stats.");
//   }
// };
// --- END: NEW SERVICE ---

export const reconnectFacebookProfile = async (platformId) => {
try {
const response = await axiosServices.post(`/facebook/reconnect`, {
platform_id: platformId,
origin: window.location.origin,
});
return response.data;
} catch (error) {
console.error("Error initiating Facebook reconnect:", error);
throw new Error(
error?.response?.data?.message || "Error initiating reconnect."
);
}
};

export const reconnectPinterestProfile = async (platformId) => {
try {
const response = await axiosServices.post(`/pinterest/reconnect`, {
platform_id: platformId,
});
return response.data;
} catch (error) {
console.error("Error initiating Pinterest reconnect:", error);
throw new Error(
error?.response?.data?.message || "Error initiating Pinterest reconnect."
);
}
};

export const reconnectInstagramProfile = async (platformId) => {
try {
const response = await axiosServices.post(`/instagram/reconnect`, {
platform_id: platformId,
});
return response.data;
} catch (error) {
console.error("Error initiating Instagram reconnect:", error);
throw new Error(
error?.response?.data?.message || "Error initiating Instagram reconnect."
);
}
};

export const reconnectLinkedInProfile = async (platformId) => {
try {
const response = await axiosServices.post(`/linkedin/reconnect`, {
platform_id: platformId,
});
return response.data;
} catch (error) {
console.error("Error initiating LinkedIn reconnect:", error);
throw new Error(
error?.response?.data?.message || "Error initiating LinkedIn reconnect."
);
}
};

export const reconnectLinkedInBusinessProfile = async (platformId) => {
try {
const response = await axiosServices.post(`/linkedin/business/reconnect`, {
platform_id: platformId,
});
return response.data;
} catch (error) {
console.error("Error initiating LinkedIn Company Page reconnect:", error);
throw new Error(
error?.response?.data?.message || "Error initiating LinkedIn Company Page reconnect."
);
}
};

export const reconnectYouTubeProfile = async (channelId) => {
try {
const response = await axiosServices.post(`/youtube/reconnect`, {
channelId,
});
return response.data;
} catch (error) {
console.error("Error initiating YouTube reconnect:", error);
throw new Error(
error?.response?.data?.message || "Error initiating YouTube reconnect."
);
}
};

export const reconnectTikTokProfile = async (platformId) => {
try {
const response = await axiosServices.post(`/tiktok/reconnect`, {
platform_id: platformId,
});
return response.data;
} catch (error) {
console.error("Error initiating TikTok reconnect:", error);
throw new Error(
error?.response?.data?.message || "Error initiating TikTok reconnect."
);
}
};

export const finalizeFacebookConnection = async (selectedPages, stateToken) => {
try {
const response = await axiosServices.post('/facebook/finalize-connection', {
selectedPages,
stateToken,
});
return response.data;
} catch (error) {
console.error("Error in finalizeFacebookConnection service:", error);
throw new Error(error.response?.data?.message || "Failed to save selected pages.");
}
};

export const fetchUserProfile = async () => {
try {
const response = await axiosServices.get(`/user/profile`);
return response.data;
} catch (error) {
console.error("Error fetching user profile:", error);
throw new Error(
error?.response?.data?.message || "Error fetching user profile."
);
}
};

export const fetchUserProfiles = async () => {
try {
const response = await axiosServices.get(`/profiles/get-profile`);
return response.data.profiles;
} catch (error) {
console.error("Error fetching user profiles:", error);
throw new Error(
error?.response?.data?.message || "Error fetching user profiles."
);
}
};

export const deleteUserData = async (storage) => {
try {
const response = await axiosServices.get(`/user/profile`);
if (response.data.user.status !== "completed") {
if (storage === "localStorage") {
localStorage.removeItem("Email");
localStorage.removeItem("user_Token");
} else if (storage === "sessionStorage") {
sessionStorage.removeItem("Email");
sessionStorage.removeItem("user_Token");
}
}
} catch (error) {
console.error("Error deleting user data:", error);
throw new Error(
error?.response?.data?.message || "Error deleting user data."
);
}
};

export const getPagesDetails = async (accessToken) => {
try {
const response = await axiosServices.post("/facebook/pages", {
accessToken,
});
return response;
} catch (error) {
console.error("Error in getPagesDetails:", error);
throw error;
}
};

export const getProfile = async () => {
try {
const response = await axiosServices.post(
"/profiles/get-platform-profile",
{
platform: "FACEBOOK",
}
);
return response;
} catch (error) {
console.error("Error in getProfile:", error);
throw error;
}
};

export const facebookCallback = async (code, state) => {
try {
const response = await axiosServices.get("/facebook/auth/callback", {
params: { code, state },
});
return response.data;
} catch (error) {
console.error("Error in facebookCallback:", error);
throw error;
}
};

export const instagramCallback = async (code, state) => {
try {
const response = await axiosServices.get(`/instagram/auth/callback`, {
params: { code, state }
});
return response.data;
} catch (error) {
console.error("Error in instagramCallback service:", error);
throw error;
}
};

export const finalizeInstagramConnection = async (payload) => {
try {
const response = await axiosServices.post(`/instagram/finalize-connection`, payload);
return response.data;
} catch (error) {
console.error("Error in finalizeInstagramConnection service:", error);
throw error;
}
};

export const saveProfiles = async (groupName, selectedPages) => {
try {
const payload = {
groupName,
connectedAccounts: selectedPages,
newlyConnectedProfile: selectedPages,
};
const response = await axiosServices.post("/group/create", payload);
return response.data;
} catch (error) {
console.error("Error in saveProfiles:", error);
throw error;
}
};

export const savePageDetails = async (facebookACId, pageDetails) => {
try {
const response = await axiosServices.post("/profiles/update-page-details", {
platform: "FACEBOOK",
user_id: facebookACId,
pageDetails,
});
return response;
} catch (error) {
console.error("Error in savePageDetails:", error);
throw error;
}
};

export const getGroups = async () => {
try {
const response = await axiosServices.get(`/group/get`);
return response.data.groups;
} catch (error) {
console.error("Error fetching groups:", error);
throw new Error("Error fetching groups");
}
};

export const handleOnboarding = async (data) => {
try {
// Changed from '/add-onboarding' to '/add-onboarding2'
await axiosServices.patch("/onboarding/add-onboarding2", {
...data,
});
return { success: true };
} catch (error) {
console.error("Error in onboarding process:", error);
throw error; // Re-throw the error to be handled by the component
}
};

export const createGroup = async (data) => {
try {
const response = await axiosServices.post(`/group/create`, {
...data,
});
return response.data;
} catch (error) {
console.error("Error in createGroup service:", error);
if (error.response?.status === 403 && error.response?.data?.errorType === 'LIMIT_REACHED') {
throw error;
}
throw new Error(error.response?.data?.message || "An error occurred during group creation.");
}
};

export const getPlans = async () => {
try {
// --- START: THIS IS THE FIX ---
// Changed the endpoint from '/api/payment/fetch-plans' to the correct public endpoint.
// We use the base axios instance because this is a public route and doesn't need a token.
const response = await axiosServices.get(`/common/plans`);
// --- END: THIS IS THE FIX ---
return response.data;
} catch (error) {
console.error("Error fetching plans:", error);
throw new Error("Error fetching plans");
}
};

export const createSubscription = async ({
planType,
email_id,
firstName,
contact,
razorpay_customer_id,
plan_id,
}) => {
try {
const response = await axiosServices.post(
`/api/payment/create-subscription`,
{
planType,
email_id,
firstName,
contact,
razorpay_customer_id,
plan_id,
}
);
return response.data;
} catch (error) {
console.error("Subscription creation failed:", error);
throw error;
}
};


export const cancelSubscription = async () => {
try {
const response = await axiosServices.post(`/api/payment/cancel-subscription`);
return response.data;
} catch (error) {
console.error("Error cancelling subscription:", error);
throw new Error(error?.response?.data?.error || "Failed to cancel subscription.");
}
};

export const fetchInvoices = async () => {
try {
const response = await axiosServices.get(`/api/payment/invoices`);
return response.data;
} catch (error) {
console.error("Error fetching invoices:", error);
throw new Error(error?.response?.data?.error || "Failed to fetch invoices.");
}
};

export const fetchUpcomingInvoice = async () => {
try {
const response = await axiosServices.get(`/api/payment/upcoming-invoice`);
return response.data;
} catch (error) {
console.error("Error fetching upcoming invoice:", error);
throw new Error(error?.response?.data?.error || "No upcoming bill found.");
}
};

export const uploadImage = async (files) => {
const formData = new FormData();
files.forEach((file) => {
formData.append("files", file);
});

try {
const response = await axiosServices.post("/upload", formData, {
headers: {
"Content-Type": "multipart/form-data",
},
});
return response.data;
} catch (error) {
console.error("Error uploading image:", error);
throw error;
}
};

export const uploadSingleImage = async (file, groupId) => {
if (!groupId) {
throw new Error("groupId is required to upload a file.");
}

const formData = new FormData();
formData.append("file", file);
formData.append("groupId", groupId);

try {
const response = await axiosServices.post("/single-upload", formData);
return response.data;
} catch (error) {
if (error.response?.status === 403 && error.response?.data?.errorType === 'LIMIT_REACHED') {
const limitError = new Error(error.response.data.message);
limitError.isLimitError = true;
limitError.feature = 'Media Storage';
throw limitError;
}
console.error("Error uploading image:", error);
throw error;
}
};

export const singleUpload = async (file, brandName, setProgress) => {
const formData = new FormData();
formData.append("file", file);
formData.append("brandName", brandName);

try {
const response = await axiosServices.post("/single-upload", formData, {
headers: {
"Content-Type": "multipart/form-data",
},
onUploadProgress: (progressEvent) => {
if (setProgress) {
const percentCompleted = Math.round(
(progressEvent.loaded * 100) / progressEvent.total
);
setProgress(percentCompleted);
}
},
});
return response.data;
} catch (error) {
console.error("Error uploading image:", error);
throw error;
}
};

export const updateGroupName = async (oldGroupName, newGroupName) => {
try {
const response = await axiosServices.post(`/group/update`, {
oldGroupName: oldGroupName,
newGroupName: newGroupName,
});
return response;
} catch (error) {
console.error("Error updating group name:", error);
throw new Error(
error?.response?.data?.message || "Error updating group name."
);
}
};

export const deleteGroupName = async (groupName) => {
try {
const response = await axiosServices.post(`/group/delete`, {
groupName: groupName,
});
return response;
} catch (error) {
console.error("Error deleting group:", error);
throw new Error(
error?.response?.data?.error ||
error?.response?.data?.message ||
"Error deleting group."
);
}
};


export const deleteConnectedProfile = async (data) => {
try {
const response = await axiosServices.post(`/group/delete-profile`, data);
return response.data;
} catch (error) {
console.error("Error deleting connected profile:", error);
throw new Error(
error?.response?.data?.message || "Error deleting connected profile."
);
}
};

export const fetchBillingDetails = async () => {
try {
const response = await axiosServices.get(`/user/billing-details`);
return response.data;
} catch (error) {
console.error("Error fetching billing details:", error);
throw new Error(error?.response?.data?.message || "Failed to fetch billing details.");
}
};

export const fetchAddonBundles = async () => {
try {
const response = await axiosServices.get('/api/payment/bundles');
return response.data.bundles || [];
} catch (error) {
console.error("Error fetching add-on bundles:", error);
throw new Error(error.response?.data?.error || "Failed to fetch bundles.");
}
};

/**
* Creates a Razorpay order for a specific add-on bundle.
* @param {string} bundleId - The unique ID of the bundle to purchase.
*/
export const createAddonOrder = async (bundleId) => {
try {
const response = await axiosServices.post('/api/payment/create-order', { bundleId });
return response.data;
} catch (error) {
console.error("Error creating add-on order:", error);
throw new Error(error.response?.data?.error || "Failed to create payment order.");
}
};

export const checkUserSubscriptionStatus = async () => {
try {
const response = await axiosServices.get(`/user/check-subscription-status`);
return response.data;
} catch (error) {
console.error("Error checking subscription status:", error);
throw new Error(error?.response?.data?.message || "Failed to check status.");
}
};